import { render } from "./FormText.vue?vue&type=template&id=f896c484"
import script from "./FormText.vue?vue&type=script&lang=js"
export * from "./FormText.vue?vue&type=script&lang=js"

import "./FormText.vue?vue&type=style&index=0&id=f896c484&lang=css"
script.render = render

export default script